import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Contact Model
import VuexORM from '@vuex-orm/core';
import City from "./City";
import State from "./State";
import Company from "./Company";
import ContactAgent from "./ContactAgent";
import { i18n } from "../../boot/i18n";
var Contact = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Contact, _VuexORM$Model);
  var _super = _createSuper(Contact);
  function Contact() {
    _classCallCheck(this, Contact);
    return _super.apply(this, arguments);
  }
  _createClass(Contact, null, [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'contacts';
    }
  }, {
    key: "fields",
    value:
    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        id: this.attr(null),
        name: this.attr(null),
        city_id: this.attr(''),
        city: this.belongsTo(City, 'city_id'),
        state_id: this.attr(''),
        state: this.belongsTo(State, 'state_id'),
        address: this.attr(''),
        phone: this.attr(''),
        email: this.attr(''),
        taxcode: this.attr(''),
        description: this.attr(''),
        type: this.attr(''),
        location: this.attr(''),
        latitude: this.attr(''),
        longitude: this.attr(''),
        company_id: this.attr(''),
        company: this.belongsTo(Company, 'owner_company_id'),
        logo: this.attr(''),
        logo_res: this.attr(''),
        personal_contact: this.boolean(''),
        agents: this.hasMany(ContactAgent, 'contact_id', 'id')
      };
    }
  }]);
  return Contact;
}(VuexORM.Model);
_defineProperty(Contact, "TYPE_OPTIONS", [{
  label: i18n.t('app.contacts.types.construction_company'),
  value: 'construction_company'
}, {
  label: i18n.t('app.contacts.types.salesman'),
  value: 'salesman'
}, {
  label: i18n.t('app.contacts.types.real_estate'),
  value: 'real_estate'
}, {
  label: i18n.t('app.contacts.types.designer'),
  value: 'designer'
}, {
  label: i18n.t('app.contacts.types.installer'),
  value: 'installer'
}, {
  label: i18n.t('app.contacts.types.related_company'),
  value: 'related_company'
}, {
  label: i18n.t('app.contacts.types.bank'),
  value: 'bank'
}, {
  label: i18n.t('app.contacts.types.private'),
  value: 'private'
}, {
  label: i18n.t('app.contacts.types.other'),
  value: 'other'
}]);
export { Contact as default };